import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthLayout } from "../../components/AuthLayout";
import { api } from "../../lib/api";
import type { RecipeListItem } from "../../lib/types";

export function Welcome() {
  const navigate = useNavigate();
  const [starters, setStarters] = useState<RecipeListItem[]>([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get<{ recipes: RecipeListItem[] }>("/recipes?sort=Quickest&limit=3").then((r) => setStarters(r.recipes));
  }, []);

  async function startFirst() {
    if (!starters[0]) return navigate("/recipes");
    setBusy(true);
    try {
      const { batchId } = await api.post<{ batchId: string }>("/batches", { recipeId: starters[0].id });
      navigate(`/batches?justStarted=${batchId}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      posterTitle="Nothing on the shelf yet."
      posterBody="That's the only time this screen looks like this. Pick something short and get a jar going tonight."
    >
      <span className="eyebrow">You're in · shelf empty</span>
      <h2 style={{ margin: "12px 0 0", fontSize: 38, lineHeight: 1.05, letterSpacing: "-0.028em", marginLeft: "-0.055em" }}>
        Get one jar going
      </h2>
      <p style={{ margin: "16px 0 26px", fontSize: 15, lineHeight: 1.65 }} className="muted">
        Nothing's resting yet, so there's nothing to check on.{" "}
        {starters.length > 0 && "Three of these you can start with what you told us is in the cupboard."}
      </p>

      <div style={{ borderTop: "2px solid var(--color-divider)" }}>
        {starters.map((s) => (
          <div
            key={s.id}
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(0,1fr) 96px",
              gap: 16,
              alignItems: "center",
              padding: "16px 0",
              borderBottom: "1px solid var(--color-divider)",
            }}
          >
            <span style={{ minWidth: 0 }}>
              <span style={{ display: "block", fontFamily: "var(--font-heading)", fontWeight: 800, fontSize: 17, letterSpacing: "-0.014em" }}>
                {s.title}
              </span>
              <span className="muted" style={{ display: "block", marginTop: 5, fontSize: 13, lineHeight: 1.55 }}>
                {s.blurb}
              </span>
            </span>
            <span style={{ textAlign: "right" }}>
              <span className="tabular" style={{ display: "block", fontFamily: "var(--font-heading)", fontWeight: 800, fontSize: 15, color: "var(--color-accent-700)" }}>
                {s.days}
              </span>
              <span className="muted-strong" style={{ display: "block", marginTop: 3, fontSize: 11.5 }}>
                {s.abv}
              </span>
            </span>
          </div>
        ))}
      </div>

      <div className="flex-row" style={{ marginTop: 24, flexWrap: "wrap" }}>
        <button className="btn btn-primary" style={{ minHeight: 46 }} onClick={startFirst} disabled={busy}>
          {starters[0] ? `Start the ${starters[0]!.title.split(",")[0]!.split(" ")[0]} one` : "Start a batch"}
        </button>
        <button className="btn btn-secondary" style={{ minHeight: 46 }} onClick={() => navigate("/recipes")}>
          Browse all recipes
        </button>
      </div>
      <p className="muted" style={{ margin: "24px 0 0", fontSize: 13.5, lineHeight: 1.6 }}>
        Or head straight to{" "}
        <button className="btn btn-ghost" style={{ padding: 0, fontSize: "inherit" }} onClick={() => navigate("/")}>
          your bench
        </button>
        .
      </p>
    </AuthLayout>
  );
}
